// frontend/src/lib/zIndex.ts
// One stacking ladder. Sixteen ad-hoc z-index values were in use across the
// app (0 … 1100) with no ordering anyone could check, and it was wrong where it
// mattered: the argument's start/resume gate rendered at 50 while the sticky
// header renders at 100, so the nav bar stayed visible AND clickable straight
// through what is supposed to be a blocking scrim. Named rungs, one file.
//
// Mirrors the --z-* custom properties in public/colors_and_type.css; the CSS
// copy is for stylesheet rules, this one is for inline React styles.
export const Z = {
  base: 0,
  raised: 1,
  /** Sticky content chrome that must slide UNDER the header (the argument's
   *  command bar, which sticks just below it). */
  stickySub: 40,
  /** Transient decorative overlays in flight (the XP reward orbs). Above the
   *  command bar they fly to, below the header, and never interactive. */
  flyaway: 80,
  /** Sticky page chrome (the header). */
  sticky: 100,
  /** Full-viewport scrims that must cover the header. */
  overlay: 400,
  /** Menus anchored to the header, above it but below any scrim. */
  dropdown: 500,
  /** Docked, non-modal panels (the hint coach). */
  panel: 900,
  /** Blocking dialogs. */
  modal: 1000,
  /** The leave-the-argument dialog, which can be raised ON TOP of a dialog. */
  leave: 1100,
  /** Tooltips: above menus (a tip can be triggered from inside one) but below
   *  dialogs, which own the screen. Both floating-layer primitives used to
   *  invent their own numbers, Tooltip 300, Select 200, so a tooltip painted
   *  over an open select menu. */
  tooltip: 700,
  /** Toasts outrank everything: they report what just happened. */
  toast: 1200,
} as const;
